import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import "./CKYC.css";
import DocTypeUpload from "./DocTypeUpload";
import UploadDoc from "./UploadDoc";
import VeryficationCKYC from "./VeryficationCKYC";
import MaskedInput from "react-text-mask";
import { CentralCall } from "../CommonMethods/CentralCall";
import { ckycURL } from "../index";
import { getKYCModel } from "../HomePage/UtilityComponents/UilityFunctions";

const CKYCHome = (props) => {
    const history = useHistory();
    const [step, setStep] = useState("");
    const [DocType, setDoctype] = useState("PAN");
    const [DocID, setDocID] = useState("");
    const [Text, setText] = useState("");
    const [RedirectURL, setRedirect] = useState("");
    const [Error, setError] = useState("");
    const [KycDetails, setKYCDetails] = useState("");
    const [IsKYCDetailsFilled, setKycDetailsFilled] = useState(false);
    const [BtnText, setBTNText] = useState("Submit");
    const [AddressDetails, setAddressDetails] = useState({});
    const [IsKycAlreadyCalled, setKycAlreadyCalled] = useState(false);
    const filterKey = props.KYCDetails.FromHealth ? "CompanyValue" : "code";
    useEffect(() => {
        // console.log(DocID);
        if (props.KYCErrorMsg !== "" || props.KYCErrorMsg !== null) {
            setError(props.KYCErrorMsg);
        }
        setDocID(props.KYCDetails?.DocNumber ?? "");
        if (props.IsProposalKYC) {
            setDoctype(props.KYCDetails.DocType ?? "");
            setRedirect(props.Redirection);
            setStep(props.step);
            setKycDetailsFilled(true);
            setKycAlreadyCalled(props.IsKycAlreadyCalled);
        } else {
            setDoctype(props.CKYCData?.filter(row => row.name.match("PAN"))[0][filterKey]);
        }
        setAddressDetails(props.KYCDetails.AddressDetails);
    }, [props.IsProposalKYC]);

    useEffect(() => {
        if (IsKYCDetailsFilled && props.KycCallType !== "PROP" && !IsKycAlreadyCalled)
            submitForm(KycDetails.IsUploadFile, KycDetails.IsRedirectUrl,);
    }, [IsKYCDetailsFilled])
    useEffect(() => {
        let selectedKYC = props.CKYCData?.filter(row => row[filterKey] === DocType);
        selectedKYC = selectedKYC.length > 0 ? selectedKYC[0].name : "";
        setText(`Enter ${selectedKYC}`);
    }, [DocType]);

    const submitForm = (IsFileUploaded, IsRedirectUrl) => {
        setStep("");
        if (DocType !== "select" && DocID.trim() !== "") {
            setError('');
            if (props.KycCallType !== "PROP") {
                setBTNText("Please Wait...");
                let selectedKYC = props.CKYCData?.filter(row => row[filterKey] === DocType);
                selectedKYC = selectedKYC.length > 0 ? selectedKYC[0].name : "";
                const dcType = selectedKYC.toLowerCase().match("pan") ? "PAN" : selectedKYC.toLowerCase().match("adha") ? "AADHAAR" : "";
                if (checkDoc(dcType, DocID)) {
                    let NomineeDetails = props.KYCDetails.nomineeDetails;
                    if (props.CompanyID === 118) {
                        const rel = KycDetails?.Relation?.split("~");
                        NomineeDetails.RelationShip = rel?.length > 0 ? rel[1] : "";
                        NomineeDetails.Name = rel?.length > 0 ? rel[0] : "";;
                    }
/*                    const ckycmodel = {
                        EnquiryNo: props.KYCDetails.EnquiryNo,
                        InsurerID: props.CompanyID,
                        DocType: DocType,
                        DocNumber: DocID,
                        UniqueID: props.KYCDetails.TransectionID,
                        DOB: props.KYCDetails.DOB,
                        Name: props.KYCDetails.Name,
                        Gender: props.KYCDetails.Gender,
                        MobileNo: props.KYCDetails.Mobile,
                        EmailID: props.KYCDetails.Email,
                        PinCode: props.KYCDetails.PinCode,
                        TypeOfMotor: parseInt(props.KYCDetails.Type),
                        TypeOfPolicy: parseInt(props.KYCDetails.TypeOfPolicy),
                        IsCorporate: props.KYCDetails.IsCorporate,
                        OdOnly: props.KYCDetails.PolicyType === "2",
                        ThirdPartyCover: props.KYCDetails.PolicyType === "1",
                        ProductType: props.KYCDetails.ProductType,
                        IsFileUploaded,
                        IsRedirectUrl,
                        FromHealth: props.KYCDetails.FromHealth == true,
                        SelectedPOA: IsFileUploaded ? KycDetails.SelectedPOA : "",
                        SelectedPOI: IsFileUploaded ? KycDetails.SelectedPOI : "",
                        SelectedPOAValue: IsFileUploaded ? KycDetails.selectedPOAValue : "",
                        SelectedPOIValue: IsFileUploaded ? KycDetails.SelectedPOIValue : "",
                        nomineeDetails: NomineeDetails,
                        AddressDetails: {
                            CPinCode: AddressDetails.PinCode,
                            CState: AddressDetails.StateName,
                            CCity: AddressDetails.CityName,
                            CDistrict: AddressDetails.CityName,
                            CAddressLine1: AddressDetails.AddressLine1,
                            CAddressLine2: AddressDetails.AddressLine2,
                            CAddressLine3: AddressDetails.AddressLine3,
                            PAddressLine1: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine1 : AddressDetails.AddressLine1,
                            PAddressLine2: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine2 : AddressDetails.AddressLine2,
                            PAddressLine3: AddressDetails.IsChangeAddress ? AddressDetails.PerAddressLine3 : AddressDetails.AddressLine3,
                            PCity: AddressDetails.IsChangeAddress ? AddressDetails.PerCityName : AddressDetails.CityName,
                            PPinCode: AddressDetails.IsChangeAddress ? AddressDetails.PerPinCode : AddressDetails.PinCode,
                            PState: AddressDetails.IsChangeAddress ? AddressDetails.PerStateName : AddressDetails.StateName,
                            PDistrict: AddressDetails.IsChangeAddress ? AddressDetails.PerCityName : AddressDetails.CityName
                        }
                    }*/


                    const params = {
                        KYCDetails: props.KYCDetails,
                        AddressDetails: AddressDetails,
                        DocType: DocType,
                        DocID: DocID,
                        KycComponentDetails: KycDetails,
                        IsFileUploaded,
                        IsRedirectUrl
                    }
                    const ckycmodel = getKYCModel(params);
                    CentralCall({ URL: `${ckycURL}checkckycstatus`, Req: ckycmodel, ExtraField: "kyc", IsPost: true }).then(Res => {
                        const Response = Res.data.Response;
                        if (Res.data.StatusCode === 200) {
                            if (Response.CKYCStatus && props.KycCallType === "PRE")
                                submitKYCDetails(Response.CKYCStatus, Response.CKYCID, Response.CKYCRefID, Res.data.TransKey);
                            else if (Response.CKYCStatus && props.KycCallType === "POST")
                                history.push("/Summary", props.ProposalData);
                        } else if (Res.data.StatusCode === 480) {
                            if (Response.IsUploadFile)
                                setStep((Response.UploadFileType === "poi,poa" || Response.UploadFileType === "poa,poi" || Response.UploadFileType === "poi" || Response.UploadFileType === "poa") ? "UploadDoc" : "UploadDocForm60");
                            else if (Response.Redirecturl) {
                                setRedirect(Response.RedirectLink);
                                setStep("Redirection");

                            }
                            else setError(Response.ErrMsg);
                            setKycDetailsFilled(false);
                        }
                        setBTNText("Submit");
                    })
                        .catch(err => {
                            setBTNText("Submit");
                            setError(err.message)
                        })

                } else {
                    setError(`Invalid ${DocType} ID`);
                }
            } else {
                submitKYCDetails(true, "", "", "");
            }
        } else {
            setError(`${(DocType === "select" && DocID.trim() !== "") ? "Select document Type" : (DocType !== "select" && DocID.trim() === "") ? "Enter Document ID" : "Enter Valid Details"}`);
        }
    }
    const checkDoc = (caseV, value) => {
        let Pattern = "";
        let result = false;
        switch (caseV.toUpperCase()) {
            case "PAN":
                Pattern = /([A-Za-z]){5}([0-9]){4}([A-Za-z]){1}$/;
                result = Pattern.test(value);
                break;
            case "AADHAAR":
                Pattern = /[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
                result = Pattern.test(value);
            default:
                result = true;
        }
        return result
    }

    const submitKYCDetails = (CKYCStatus, CKYCID, CKYCRefID, KycTransKey) => {
        const dcType = DocType.toLowerCase().match("pan") ? "PAN" : DocType.toLowerCase().match("adha") ? "AADHAAR" : "";
        if (checkDoc(dcType, DocID)) {

            const kycModel = {
                "DocType": DocType,
                "DocNumber": DocID,
                Base64Photo: "", //KycDetails.Base64Photo,
                Base64POI: "", //KycDetails.Base64POI,
                Base64POA: "", //KycDetails.Base64POA,
                isFileUploaded: KycDetails.isFileUploaded,
                SelectedPOA: KycDetails.SelectedPOA,
                SelectedPOI: KycDetails.SelectedPOI,
                SelectedPOIValue: KycDetails.SelectedPOIValue,
                selectedPOAValue: KycDetails.selectedPOAValue,
                CKYCStatus,
                CKYCID,
                CKYCRefID,
                KycTransKey,
                FromHealth: props.KYCDetails.FromHealth
            }
            props.onKycSubmit(kycModel);
        } else {
            const dt = props.CKYCData?.filter(row => row.name.match("PAN"))[0].name
            setError(`Invalid ${dt} ID`);
        }
    }



    return <>

        {
            step === "Redirection" ? <VeryficationCKYC onKYCSubmit={(data) => submitForm(data.IsUploadFile, data.IsRedirectUrl)} setKYCDetails={(data) => setKYCDetails(data)} CKYCData={props.CKYCData} URL={RedirectURL} EnquiryNo={props.EnquiryNo} DocID={DocID} Companyid={props.CompanyID} closeKYC={props.closeKYC} /> :
                step === "UploadDocForm60" ? <UploadDoc title="form60" closeKYC={props.closeKYC} setKYCDetails={(data) => {
                    setKYCDetails(data);
                    setKycDetailsFilled(true);
                }} CKYCData={props.CKYCData} EnquiryNo={props.EnquiryNo} Companyid={props.CompanyID} onKycSubmit={props.closeKYC} /> :
                    step === "UploadPhoto" ? <UploadDoc title="photo" onKYCSubmit={props.closeKYC} setKYCDetails={(data) => {
                        setKYCDetails(data);
                        setKycDetailsFilled(true);
                    }} CKYCData={props.CKYCData} EnquiryNo={props.EnquiryNo} Companyid={props.CompanyID} onKycSubmit={props.closeKYC} /> :
                        step === "UploadDoc" ? <DocTypeUpload onKYCSubmit={props.closeKYC} setKYCDetails={(data) => {
                            console.log("doc uploaded")
                            setKYCDetails(data);
                            setKycDetailsFilled(true);
                        }} CKYCData={props.CKYCData} EnquiryNo={props.EnquiryNo} Companyid={props.CompanyID} onKycSubmit={props.closeKYC} /> : <>
                            <div className="modal fade show" id="exampleModalDefault" style={{ display: "block" }} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                <div className="modal-dialog ckyc_verification_POP">
                                    <div className="modal-content CkycUploadDOC">
                                        <div className="modal-header d-flex">
                                            <h1 className="modal-title fs-5" id="exampleModalLabel">KYC Verification</h1>
                                            <button type="button" className="close" onClick={() => props.closeKYC(false)}>X</button>
                                        </div>
                                        <div className="modal-body">
                                            <div className="row">
                                                <div className="ckyc_INPBox">
                                                    <span className="text-danger mb-3">{Error}</span>
                                                    <div className="form-group">
                                                        <div className="fillFields">
                                                            <label>
                                                                <select className="packageForm" name="CKYCDropdown" value={DocType} onChange={(e) => setDoctype(e.target.value)}>
                                                                    <option value="select">Select Document Type</option>
                                                                    {props.CKYCData.map((row, i) => <option key={i} value={row[filterKey]}>{row.name}</option>)}
                                                                </select>
                                                            </label>
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        {Text.toLowerCase().match("pan") ? <MaskedInput mask={[/[a-zA-z]/, /[a-zA-z]/, /[a-zA-z]/, /[a-zA-z]/, /[a-zA-z]/, /\d/, /\d/, /\d/, /\d/, /[a-zA-Z]/,]} placeholder={Text} name={DocType} value={DocID} onChange={(e) => setDocID(e.target.value)} className="packageForm CKYC_Input" guide={false} showMask={false} style={{ textTransform: "uppercase" }} />
                                                            :
                                                            < input type="text" placeholder={Text} name={DocType} value={DocID} onChange={(e) => setDocID(e.target.value)} className="packageForm CKYC_Input" />}
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <small className="CKYC_MSg">You can select another document if you don’t have PAN card</small>
                                                </div>
                                                </div>
                                            <div className="CKYC_Submit_btn">
                                                <input type="button" value={BtnText} onClick={!props.IsProposalKYC && (props.CompanyID === 124 || props.CompanyID === 101 || props.CompanyID === 118 || props.CompanyID === 128 || props.CompanyID === 148) ? () => submitKYCDetails(false, "", "") : () => submitForm(false, false)} className="fileUploadBtn" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
        }


    </>
}
export default CKYCHome;